// React Query source for outgoing shared estimates (estshare__ we sent)
// that the recipient has now accepted or declined. Shared by AlertBell and
// useOutgoingEstimateAlerts so the bell count and the toast source match.

import { useQuery } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import { listMyOutgoingResponded, type SharedEstimateDoc } from '../lib/db/shared'

export function useOutgoingSharedEstimates() {
  const { effectiveUid } = useAuth()
  return useQuery<SharedEstimateDoc[]>({
    queryKey: ['outgoingSharedEstimates', effectiveUid ?? 'anon'],
    queryFn: () => (effectiveUid ? listMyOutgoingResponded(effectiveUid) : Promise.resolve([])),
    enabled: !!effectiveUid,
    staleTime: 10_000,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
  })
}
